


































import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { Form } from 'element-ui'
import debounce from 'lodash/debounce'
enum BreakPoint {
    sm = 768,
    md = 992,
    lg = 1200,
    xl = 1920
}
@Component
export default class SearchFormComponent extends Vue {
    @Prop() private readonly searchForm!: { [key: string]: any }

    @Emit()
    onForm() {
        return this.$refs['ref']
    }

    @Emit()
    onReset(): void {
        ;(this.$refs['ref'] as Form).resetFields()
    }

    @Emit()
    onSubmit(): void {}

    onSearchEnter(event: KeyboardEvent): void {
        const target = event.target as HTMLElement | null
        if (
            event.isComposing ||
            !target ||
            target.closest('.el-select, .el-autocomplete, .el-date-editor, .el-cascader, .el-textarea')
        ) {
            return
        }
        this.onSubmit()
    }

    mounted() {
        this.onForm()
        this.initFilter()
        this.handleFilterResize()
        window.addEventListener('resize', debounce(this.handleFilterResize.bind(this), 300))
    }

    // responsive form item
    showMoreFilter = false;
    filterLength = 0;
    filterBreakStart = 1;
    filterSplit = 1;
    searchBtnOffset = 0;

    initFilter() {
        const searchFormEl = this.$refs.ref as Form
        if (!searchFormEl) {
            return
        }
        const cols = searchFormEl.$el.getElementsByClassName('el-col')
        const filterCols = Array.from(cols).filter(col => col.innerHTML !== '')
        this.filterLength = filterCols.length - 1 // except search button column
        filterCols.forEach((element, i) => {
            if (i > this.filterBreakStart && i < this.filterLength) {
                (element as HTMLElement).style.display = this.showMoreFilter ? 'block' : 'none'
            } else {
                (element as HTMLElement).style.display = 'block'
            }
        })

        let base = 8
        switch (this.filterBreakStart) {
            case 2: {
                base = 6
                break
            }
            case 1: {
                base = 8
                break
            }
            default: {
                base = 8
            }
        }

        const split = 24 / base
        const n = this.filterLength % split
        this.searchBtnOffset = (split - n - 1) * base
        this.filterSplit = split

        if (!this.showMoreFilter && this.filterLength >= split) {
            this.searchBtnOffset = 0
        }
        // console.log(this.filterLength, this.searchBtnOffset)
    }

    handleFilterResize() {
        if (window.innerWidth >= BreakPoint.xl) {
            this.filterBreakStart = 2
        } else if (window.innerWidth >= BreakPoint.md) {
            this.filterBreakStart = 1
        } else {
            this.filterBreakStart = 0
        }

        this.initFilter()
    }

    fliterMoreHandler() {
        this.showMoreFilter = !this.showMoreFilter
        this.initFilter()
    }
}
